import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

export default function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://cassandras.be/">
        Cassandras
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
